var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"py-3 bg-dark text-light text-center"},[_c('p',{staticClass:"m-0"},[_vm._v("© "+_vm._s(_vm.date)+" WBA Future Leaders All Rights Reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }